import { fromClass } from "fw-model";

export class SearchResult<TModel> {
    @fromClass Results: TModel[];
    Aggregations: any;
    PreviousPageToken: string;
    NextPageToken: string;
    Total: number;
    Page: number; // outdated // TODO use token
}
